import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/show.png';

const _withScopeId = n => (_pushScopeId("data-v-8857aef2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "contract-item"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "header"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "multiple"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_9 = {
  key: 2,
  style: {
    "font-size": "13px",
    "color": "#D04C64"
  }
};
const _hoisted_10 = {
  key: 3,
  style: {
    "font-size": "13px",
    "color": "#919497"
  }
};
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  key: 0,
  class: "tag",
  style: {
    "--color": "#04AC92",
    "--bColor": "#E4F7F1"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "tag",
  style: {
    "--color": "#D04C64",
    "--bColor": "#FBF3F1"
  }
};
const _hoisted_14 = {
  key: 2,
  class: "date"
};
const _hoisted_15 = {
  key: 3,
  class: "date"
};
const _hoisted_16 = {
  style: {
    "font-size": "13px",
    "padding-bottom": "5px",
    "color": "#969799",
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_17 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 2,
  class: "num"
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 2
};
const _hoisted_22 = {
  class: "label"
};
const _hoisted_23 = {
  class: "num"
};
const _hoisted_24 = {
  class: "label mt"
};
const _hoisted_25 = {
  class: "num"
};
const _hoisted_26 = {
  class: "label mt"
};
const _hoisted_27 = {
  class: "num"
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  key: 2
};
const _hoisted_30 = {
  class: "label"
};
const _hoisted_31 = {
  class: "num"
};
const _hoisted_32 = {
  class: "label mt"
};
const _hoisted_33 = {
  class: "num"
};
const _hoisted_34 = {
  class: "label mt"
};
const _hoisted_35 = {
  class: "num"
};
const _hoisted_36 = {
  class: "label"
};
const _hoisted_37 = {
  class: "num"
};
const _hoisted_38 = {
  class: "label"
};
const _hoisted_39 = {
  class: "num"
};
const _hoisted_40 = {
  class: "label"
};
const _hoisted_41 = {
  class: "num"
};
const _hoisted_42 = {
  class: "label"
};
const _hoisted_43 = {
  class: "num"
};
const _hoisted_44 = {
  class: "label"
};
const _hoisted_45 = {
  class: "num"
};
const _hoisted_46 = {
  class: "label"
};
const _hoisted_47 = {
  key: 0,
  class: "num",
  style: {
    "color": "#04AC92"
  }
};
const _hoisted_48 = {
  key: 1,
  class: "num",
  style: {
    "color": "#D04C64"
  }
};
import { ref } from 'vue';
import { Dialog, Toast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import { contractType } from '@/util/type';
import { futureCancel } from '@/apis';
import BigNumber from "bignumber.js";
import { useI18n } from "vue-i18n";
import { fmtNumber } from '@/util';
export default {
  __name: 'ContractItem',
  props: {
    id: {
      type: Number
    },
    name: {
      type: String,
      default: '--'
    },
    multiple: {
      type: Number
    },
    side: {
      type: Number,
      default: 0
    },
    time: {
      type: String,
      default: '--'
    },
    openNum: {
      type: String,
      default: '0'
    },
    holdNum: {
      type: String,
      default: '0'
    },
    warrant: {
      type: String,
      default: '0'
    },
    fee: {
      type: String,
      default: '0'
    },
    profit: {
      type: String,
      default: '0'
    },
    status: {
      type: Number,
      default: 0
    },
    last: {
      type: String,
      default: '0'
    },
    margin: {
      type: String,
      default: '0'
    },
    openPrice: {
      type: String,
      default: '0'
    },
    sl: {
      type: String,
      default: '0'
    },
    tp: {
      type: String,
      default: '0'
    },
    close: {
      type: Number,
      default: 0
    },
    lastText: {
      type: String,
      default: '--'
    },
    closeTime: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    mergeKey: {
      type: String,
      default: ''
    },
    orderNum: {
      type: Number,
      default: 1
    },
    icon: {
      type: String,
      default: ''
    }
  },
  emits: ['init', 'set', 'set1', 'showFutureChild'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const color = ref('#04AC92');

    const cancelOrder = () => {
      const beforeClose = action => {
        return new Promise(resolve => {
          if (action === 'confirm') {
            futureCancel({
              id: props.id
            }).then(res => {
              if (res.code !== 200) {
                Toast({
                  message: res.msg ? res.msg : t('cancelError'),
                  position: "bottom"
                });
                resolve(false);
                return;
              }

              Toast({
                message: t('cancelSuccess'),
                position: "bottom"
              });
              emit('init');
              resolve(true);
            });
          } else {
            resolve(true);
          }
        });
      };

      Dialog.confirm({
        title: t('tip'),
        message: t('cancelTip'),
        cancelButtonText: t('cancelText'),
        confirmButtonText: t('confirmText'),
        beforeClose
      }).catch(() => {});
    };

    const getProfit = () => {
      if (props.last !== '--') {
        const decimal = 4;
        let price = BigNumber(props.warrant).multipliedBy(props.multiple).multipliedBy(props.last).dividedBy(props.openPrice).minus(BigNumber(props.warrant).multipliedBy(props.multiple)).toFixed(decimal);
        if (props.side) price = 0 - price;else price = Number(price);
        if (price >= 0) color.value = '#04AC92';else color.value = '#D04C64';
        return fmtNumber(price);
      }

      return 0;
    };

    const getProfitRate = () => {
      if (props.last !== '--') {
        let price = BigNumber(getProfit()).dividedBy(props.warrant).multipliedBy(100).toFixed(2);
        return Number(price);
      }

      return 0;
    }; // const closeOrder = async () => {
    //   futureClose({ 'mergeKey': props.mergeKey }).then(res => {
    //     if (res.code !== 200) {
    //       Toast({ message: res.msg ? res.msg : t('unwindError'), position: "bottom" })
    //       emit('init')
    //       return
    //     }
    //     Toast({ message: t('unwindSuccess'), position: "bottom" })
    //     emit('init')
    //   })
    // }


    return (_ctx, _cache) => {
      const _component_van_col = _resolveComponent("van-col");

      const _component_van_row = _resolveComponent("van-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: props.icon,
        alt: "",
        style: {
          "width": "1.4286rem",
          "margin-right": ".3571rem"
        }
      }, null, 8, _hoisted_5), _createTextVNode(_toDisplayString(props.name) + "/USDT", 1), _createElementVNode("span", _hoisted_6, _toDisplayString(props.multiple) + "X", 1), props.orderNum > 1 && props.index == 1 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_0,
        alt: "",
        style: {
          "width": "35px",
          "margin-left": "10px"
        },
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('showFutureChild', props.mergeKey))
      })) : _createCommentVNode("", true)]), props.status === _unref(contractType).entrust && props.index == 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "btn",
        onClick: _withModifiers(cancelOrder, ["stop"])
      }, _toDisplayString(_unref(t)('cancelOrder')), 9, _hoisted_7)) : props.status === _unref(contractType).open && props.index == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", {
        class: "btn",
        style: {
          "margin-right": "6px"
        },
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => emit('set', props.id), ["stop"]))
      }, _toDisplayString(_unref(t)('setting')), 1), _createElementVNode("div", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => emit('set1', props.id, props.warrant), ["stop"]))
      }, _toDisplayString(_unref(t)('unwind')), 1)])) : props.status === _unref(contractType).cancel ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)('canceled')), 1)) : _createCommentVNode("", true), props.index == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [props.close === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(_unref(t)('handUnwind')), 1)], 64)) : props.close === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(_unref(t)('blowUp')), 1)], 64)) : props.close === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createTextVNode(_toDisplayString(_unref(t)('sl')), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 3
      }, [_createTextVNode(_toDisplayString(_unref(t)('tp')), 1)], 64))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [props.side == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(t)('toBuy')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(t)('toSell')), 1)), props.index != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(props.time), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(props.closeTime), 1))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(_unref(t)('tp')) + "：" + _toDisplayString(props.tp ? props.tp : 0), 1), _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('sl')) + "：" + _toDisplayString(props.sl ? props.sl : 0), 1)]), props.index == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [props.status === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({
          color: color.value
        })
      }, _toDisplayString(getProfit()), 5)) : props.status === 2 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "num",
        style: _normalizeStyle({
          color: props.profit >= 0 ? '#04AC92' : '#D04C64'
        })
      }, _toDisplayString(_unref(fmtNumber)(props.profit)), 5)) : (_openBlock(), _createElementBlock("div", _hoisted_19, "--"))])) : _createCommentVNode("", true), props.index == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(fmtNumber)(props.warrant)), 1)) : _createCommentVNode("", true), props.index == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(props.profit), 1)) : _createCommentVNode("", true)]), _createVNode(_component_van_row, null, {
        default: _withCtx(() => [props.index == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_van_col, {
          span: "8",
          class: "data-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('openNum')), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(fmtNumber)(props.openNum)), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('warrant')), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(fmtNumber)(props.warrant)), 1), props.index == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('profitP')), 1), _createElementVNode("div", _hoisted_27, [props.status === 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: _normalizeStyle({
              color: color.value
            })
          }, _toDisplayString(getProfitRate()) + "%", 5)) : props.status === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString((props.profit / props.warrant * 100).toFixed(2)) + "%", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_29, "--"))])], 64)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "center"
          }
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "right"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('openPrice')), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(fmtNumber)(props.openPrice)), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('fee')), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(fmtNumber)(props.fee)), 1), _createElementVNode("div", _hoisted_34, _toDisplayString(props.lastText), 1), _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(fmtNumber)(props.last)), 1)]),
          _: 1
        })], 64)) : _createCommentVNode("", true), props.index == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createVNode(_component_van_col, {
          span: "8",
          class: "data-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('openNum')), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(fmtNumber)(props.openNum)), 1)]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "center"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_38, _toDisplayString(_unref(t)('openPrice')), 1), _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(fmtNumber)(props.openPrice)), 1)])]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "right"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('fee')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(fmtNumber)(props.fee)), 1)]),
          _: 1
        })], 64)) : _createCommentVNode("", true), props.index == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createVNode(_component_van_col, {
          span: "8",
          class: "data-item"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('warrant')), 1), _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(fmtNumber)(props.warrant)), 1)]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "center"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_44, _toDisplayString(props.lastText), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(fmtNumber)(props.last)), 1)]),
          _: 1
        }), _createVNode(_component_van_col, {
          span: "8",
          class: "data-item",
          style: {
            "text-align": "right"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('profitP')), 1), (props.profit / props.warrant * 100).toFixed(2) >= 0 ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString((props.profit / props.warrant * 100).toFixed(2)) + "%", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString((props.profit / props.warrant * 100).toFixed(2)) + "%", 1))]),
          _: 1
        })], 64)) : _createCommentVNode("", true)]),
        _: 1
      })])]);
    };
  }

};